export const USER_CENTER_SUBJECT_STORAGE_KEY = 't-user-center-subject';
export const USER_CENTER_APP_USER_SUBJECT_STORAGE_KEY = 't-user-center-app_user-subject';
